import React from "react";
import footerBg from "../../assets/images/backgrounds/footerBg.webp";
import vision from "../../assets/images/about/vision.webp";
import visionMobile from "../../assets/images/about/visionMobile.webp"
import visionLeft from '../../assets/images/about/visionLeft.webp'
import visionRight from '../../assets/images/about/visionRight.webp'

const VisionMissionSection = () => {
  return (
    <div
      className="py-10 px-4 md:px-12 bg-no-repeat bg-cover bg-center"
      style={{
        backgroundImage: `url(${footerBg})`,
      }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-6 items-start">
        {/* Left Image */}
        <div className="w-full md:w-[30%] hidden md:block">
  <img
    src={visionLeft}
    alt="Target"
    className="w-full h-[500px] 2xl:h-[450px] object-cover rounded-xl"
  />
</div>


        {/* Vision & Mission Content */}
        <div className="w-full md:w-[70%] flex flex-col justify-between">
        {/* Vision Box */}
          <div className="flex flex-col md:flex-row gap-4">
          <img src={visionRight} alt="visionRight" className="h-48 w-full md:w-[30%] shrink-0" />
          <div className="bg-white rounded-xl shadow-md p-6 space-y-3 h-48">
            <div className="flex items-start gap-2">
              <div className="w-4 h-4 mt-1 rounded-sm bg-primary-900 rotate-[15deg]" />
              <h2 className="text-xl font-semibold">Our Vision</h2>
            </div>
            <p className="leading-relaxed text-sm md:text-base font-outfitRegular ">
              To Transform Exam Preparation By Giving Every Student The Real
              Exam Experience— So They Walk Into The Actual Test With
              Confidence, Clarity, And Control.
            </p>
          </div>
          </div>

          {/* Mission Box */}
          <div className="bg-white rounded-xl shadow-md p-6 space-y-3 md:w-[100%] mt-5">
            <div className="flex items-start gap-2">
              <div className="w-4 h-4 mt-1 rounded-sm bg-primary-900 rotate-[15deg]" />
              <h2 className="text-xl font-semibold">Our Mission</h2>
            </div>
            <ul className="pl-2 space-y-3 text-sm md:text-base font-outfitRegular">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 mt-1 bg-primary-900 rotate-[15deg] shrink-0" />
                <span>
                  To Bridge The Gap Between Preparation And Performance Through
                  Authentic, Full-Scale Exam Simulations
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 mt-1 bg-primary-900 rotate-[15deg] shrink-0" />
                <span>
                  To Support Coaching Institutes With Smart Digital Tools Like{" "}
                  <span className="font-outfitSemiBold">
                    Learning Management System (LMS)
                  </span>
                  ,{" "}
                  <span className="font-outfitSemiBold">
                    Enterprise Resource Planning (ERP)
                  </span>
                  , And{" "}
                  <span className="font-outfitSemiBold">
                    Mobile Apps (Android & iOS)
                  </span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 mt-1 bg-primary-900 rotate-[15deg] shrink-0" />
                <span>
                  To Help Students Overcome Exam Anxiety With Structured,{" "}
                  <span className="font-outfitSemiBold">Real-Time Practice Environments</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 mt-1 bg-primary-900 rotate-[15deg] shrink-0" />
                <span>
                  To Improve Outcomes By Creating A Better, Tech-Enabled Exam
                  Journey—From Classroom To Test Centers.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMissionSection;
